module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"objectslink":"Alle Objekte","PAR":{"objectslink":"@:objectslink"},"MGT":{"objectslink":"@:objectslink"}},"fr":{}}')
  delete Component.options._Ctor
}
